// TOP LEVEL IMPORTS
import gql from 'graphql-tag';

export default gql`
  query getUsers($params: UserSearchParams) {
    getUsers: users(params: $params) {
      _id
      emails {
        address
        verified
      }
      roles
      organization {
        _id
        title
      }
      organizations {
        _id
        title
      }
      createdAt
      profile {
        firstName
        lastName
      }
    }
  }
`;



// WEBPACK FOOTER //
// ./src/ApolloClient/Queries/getUsers.js